'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, QuotesManagerEvent, Security, DelayedQuote } from '@benzinga/quotes-manager';
import Hooks from '@benzinga/hooks';

export const useDelayedQuote = (symbol: Security): DelayedQuote | undefined => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesManager);
  const [quote, setQuote] = React.useState<DelayedQuote | undefined>(
    () => quotesManager.getCachedQuote(symbol) as unknown as DelayedQuote,
  );

  React.useEffect(() => {
    quotesManager.getCachedQuote(symbol) as unknown as DelayedQuote;
  }, [quotesManager, symbol]);

  Hooks.useSubscriber(quotesManager, (event: QuotesManagerEvent) => {
    switch (event.type) {
      case 'get_delayed_quotes':
        if (event.quotes) {
          setQuote(event.quotes[symbol]);
        }
    }
  });
  return quote;
};
